import List from './List';
import New from './New';
import Show from './Show';

export default {
  List,
  New,
  Show
};
